import * as _ from 'lodash-es';
import {
    getQueryLangFilterCriterionVariant,
    QueryLangFilterCriterionVariant,
    QueryLangFilterOperatorExt
} from '../../enums/query-lang-filter-operator';
import {FilterCriterion} from './filter-criterion';

export class QueryLangFilterCriterion<ITEM extends Record<string, any> = any> implements FilterCriterion {
    public queryParamName: string = 'filter';
    public query: any;

    public fieldNames: Array<keyof ITEM>;
    public operator: QueryLangFilterOperatorExt;

    constructor(options?: {
        queryParamName?: string,
        query?: any,
        fieldNames?: Array<keyof ITEM>,
        operator?: QueryLangFilterOperatorExt
    }) {
        _.assign(this, options);
    }

    public apply(queryParams: {[key: string]: any}): void {
        if (this.isQuerySpecified()) {
            const queryString = this.getPrimitiveQueryValue() + ''; // be sure we have a string before passing it to API
            const criterionVariants: QueryLangFilterCriterionVariant[] = [];

            for (const name of this.fieldNames) {
                criterionVariants.push(
                    getQueryLangFilterCriterionVariant(name as string, this.operator, queryString)
                );
            }

            if (criterionVariants.length) {
                const filter = queryParams[this.queryParamName] = queryParams[this.queryParamName] || [];

                filter.push(criterionVariants);
            }
        }
    }

    public getPrimitiveQueryValue(): string {
        return this.query;
    }

    public isQuerySpecified(): boolean {
        const queryString = this.getPrimitiveQueryValue();

        return queryString != null && queryString !== '';
    }
}
